export default {
    company_agency: "Magasin",
    document: "CI",
    no_company_agency_found: "Aucun magasin trouvé",
    project_name: "Academia Inca",
}